import { render, staticRenderFns } from "./CollectionsPublic.vue?vue&type=template&id=730869aa&scoped=true&"
import script from "./CollectionsPublic.vue?vue&type=script&lang=ts&"
export * from "./CollectionsPublic.vue?vue&type=script&lang=ts&"
import style0 from "./CollectionsPublic.vue?vue&type=style&index=0&id=730869aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "730869aa",
  null
  
)

export default component.exports